export const ALERT_VARIANTS = {
  INFO: "info",
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning"
};
